/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ReviewApprovedFilled({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" {...props}><path fill="#00B58A" d="M7.828.519a2.35 2.35 0 0 1 2.344 0l5.587 3.224a2.35 2.35 0 0 1 1.172 2.032v6.449c0 .838-.447 1.613-1.172 2.031l-5.587 3.226a2.35 2.35 0 0 1-2.344 0L2.24 14.255a2.35 2.35 0 0 1-1.171-2.031v-6.45c0-.837.447-1.612 1.171-2.03z" /><path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.271} d="m4.96 8.804 2.707 2.89 5.373-5.388" /></svg>;
}
;